import { Extension } from '@tiptap/react';
export function createCustomEnterExtension() {
    // Define the customEnterExtension first
    return Extension.create({
        name: 'customEnter',
        addKeyboardShortcuts() {
            return {
                Enter: () => {
                    const editor = this.editor;
                    if (!editor || editor.isDestroyed || !editor.view || !editor.state) {
                        console.warn('[customEnter] Editor is not available, destroyed, or its view/state is missing.');
                        return false;
                    }
                    const { state } = editor;
                    const chainCommands = editor.chain();
                    if (!chainCommands || typeof chainCommands.run !== 'function') {
                        console.warn('[customEnter] editor.chain() returned an invalid object or is unavailable.');
                        return false;
                    }
                    const { $from } = state.selection;
                    const textBlockNodeType = editor.schema.nodes.textBlock;
                    const paragraphNodeType = editor.schema.nodes.paragraph;
                    if (!textBlockNodeType) {
                        console.error('[customEnter] textBlock node type not found in schema! Aborting Enter key logic.');
                        return false;
                    }
                    if ($from.depth === 1) {
                        const parentNode = $from.parent;
                        if (parentNode.type === paragraphNodeType) {
                            return chainCommands
                                .setNode(textBlockNodeType)
                                .splitBlock()
                                .run();
                        }
                        else if (parentNode.type === textBlockNodeType ||
                            parentNode.type.name === 'heading' ||
                            parentNode.type.name === 'calloutBlock') {
                            return chainCommands
                                .splitBlock()
                                .setNode(textBlockNodeType)
                                .run();
                        }
                        return chainCommands
                            .splitBlock()
                            .setNode(textBlockNodeType)
                            .run();
                    }
                    return false;
                },
            };
        },
    });
}
//# sourceMappingURL=enterExtension.js.map